import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@leverege/ui-elements'
import { connect } from 'react-redux'
import { PasswordValidatorFactory } from '@leverege/api-validator'

import { Validate } from '~/utils'
import { LabelGroup, FormValidator, Flex } from '~/views'

const num = 0;
class CreateUserDialog extends React.Component {

  static contextTypes = {
    api : PropTypes.object
  }

  static propTypes = {
    onItemSelected : PropTypes.func,
    projectId : PropTypes.string.isRequired,
    path : PropTypes.string,
    flagName : PropTypes.string,
    showFlag : PropTypes.bool,
    initialFlag : PropTypes.bool
  }

  constructor( props ) {
    super( props )
    this.state = { username : '',
                   password : '',
                   name : '',
                   email : '',
                   loading : true,
                   error : null, 
                   flag : props.initialFlag == null ? true : props.initialFlag }
  }

  componentDidMount() {
    const { dispatch, projectId } = this.props

    dispatch( async ( dispatch, getState, { api } ) => {
      const requirements = await api.project( projectId ).passwordRequirements().get()

      const pwValidator = PasswordValidatorFactory.create( requirements )

      const validator = FormValidator.create( this, 
        {
          username : {
            allow : /^[0-9a-zA-Z@.\-\+]*$/,
            validator( v ) {
              if ( v == null || typeof v !== 'string' || v.trim().length < 3 ) { return false }
              if ( v.indexOf( '@' ) > 0 && !Validate.email( v ) ) { return false }
              return true
            }
          },
          password : {
            validator( v ) {

              const result = pwValidator.validate( v )

              return result.valid
            }
          },
          email : {
            validator( v ) { return Validate.email( v ) }
          },
          phone : {
            validator( v ) { return Validate.phone( v, true ) }
          }
        }, 
        {
          onSubmit : this.onCreate
        } )

      this.setState( {
        validator
      } )
    } )
  }

  onCreate = ( ) => {
    let { username, password, name, email, phone } = this.state
    name = name && name.trim() === '' ? null : name
    phone = phone && phone.trim() === '' ? null : phone
    const user = { username, password, name, phone }
    if ( !Validate.email( username ) ) {
      user.email = email
    }
    this.props.onCreate( user )
  }

  render() {
    const { username, password, name, email, phone, validator } = this.state

    if ( !validator ) {
      return null
    }
    
    const { onHide, show } = this.props
    const usernameIsEmail = Validate.email( username )
    validator.setActive( 'email', !usernameIsEmail )

    console.log( this.state )

    return (
      <Dialog.Question
        show={show}
        title="Create User"
        okay="Create"
        onOkay={evt => validator.onSubmit( evt.sourceEvent )}
        onCancel={onHide}
        onClose={onHide}>
        <Flex variant="vSpace" align="stretch" direction="column">
          <LabelGroup>
            <label style={{ width : '6em' }}>Username</label>
            <input type="text"
              name="username"
              autoFocus
              className={validator.classnames( 'username' )} 
              placeholder="Username..."
              value={username}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Password</label>
            <input type="text"
              name="password" 
              className={validator.classnames( 'password' )} 
              placeholder="Password..."
              value={password}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }} disabled={usernameIsEmail}>Email</label>
            <input type="text"
              name="email"
              disabled={usernameIsEmail}
              className={validator.classnames( 'email' )} 
              placeholder="Email..."
              value={usernameIsEmail ? username : email}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Name</label>
            <input type="text"
              name="name" 
              className={validator.classnames( 'name' )} 
              placeholder={username || 'Name...'}
              value={name}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Phone</label>
            <input type="text"
              name="phone"
              className={validator.classnames( 'phone' )} 
              placeholder="Phone number for sms notifications..."
              value={phone}
              onChange={validator.onInputChange} />
          </LabelGroup>
        </Flex>
      </Dialog.Question>
    )
  }
}

export default connect( ( state ) => {
  return {

  }
} )( CreateUserDialog )
